module.exports = __webpack_public_path__ + "static/media/placeholder.6a3966fb.svg";